import React from "react";
import { useTranslation } from "react-i18next";
import "../App.css";

function AppPage() {
  const { t } = useTranslation();

  return (
    <div
      className="app-page"
      style={{ padding: "4rem 2rem", maxWidth: "1100px", margin: "0 auto" }}
    >
      <h1 style={{ marginBottom: "1.5rem", textAlign: "center" }}>
        {t("appPage.title")}
      </h1>
      <div style={{ display: "grid", gap: "2rem" }}>
        <p
          style={{
            fontSize: "1.15rem",
            lineHeight: "1.8",
            textAlign: "center",
          }}
        >
          {t("appPage.featureDescription")}
        </p>

        <img
          src="/images/allinoneapp.png"
          alt="Onenizer App"
          style={{
            width: "100%",
            maxWidth: "700px",
            margin: "0 auto",
            borderRadius: "12px",
          }}
        />
      </div>
    </div>
  );
}

export default AppPage;
